import { render } from "./videoPlayer.vue?vue&type=template&id=c54926b4&scoped=true"
import script from "./videoPlayer.vue?vue&type=script&lang=js"
export * from "./videoPlayer.vue?vue&type=script&lang=js"

import "./videoPlayer.vue?vue&type=style&index=0&id=c54926b4&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c54926b4"]])

export default __exports__